import React, { useRef, useLayoutEffect, useEffect } from 'react';
import PropTypes from 'prop-types';
import gsap from 'gsap';

import styles from './ButtonExpand.module.scss';

export const ButtonExpand = ({ children, onClick, expanded }) => {
  const icon = useRef(null);
  const lines = [useRef(null), useRef(null)];
  const tweens = useRef({
    expand: null,
  });

  useLayoutEffect(() => {
    if (tweens.current.expand === null) {
      tweens.current.expand = gsap.timeline({ paused: true });
      tweens.current.expand.to(
        icon.current,
        { rotate: 180, duration: 0.5, ease: 'power2.inOut' },
        0.0
      );
      tweens.current.expand.to(
        lines[0].current,
        { rotate: 0, duration: 0.5, ease: 'power2.inOut' },
        0.0
      );
      tweens.current.expand.to(
        lines[1].current,
        { rotate: 0, duration: 0.5, ease: 'power2.inOut' },
        0.0
      );
    }

    if (expanded) {
      tweens.current.expand.play();
    } else {
      tweens.current.expand.reverse();
    }
  }, [expanded]);

  useEffect(
    () => () => {
      if (tweens.current.expand) {
        tweens.current.expand.kill();
        tweens.current.expand = null;
      }
    },
    []
  );

  return (
    <button
      onClick={onClick}
      type="button"
      className={styles.button}
      aria-expanded={expanded ? 'true' : 'false'}
    >
      {children}
      <span className={styles.icon} ref={icon}>
        <span className={styles.line} ref={lines[0]} />
        <span className={styles.line} ref={lines[1]} />
      </span>
    </button>
  );
};

ButtonExpand.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any.isRequired,
  onClick: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
};
